import { render, staticRenderFns } from "./AddComment.vue?vue&type=template&id=289f0194"
import script from "./AddComment.vue?vue&type=script&lang=js"
export * from "./AddComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports